import { useEffect, useState } from "react";
import {
    usePortfolioSelection,
    usePortfolioManagement,
    usePortfolioProfile,
} from "../../../shared/contexts/portfolio-context/components/PortfolioContextProvider";
import BalanceIcon from '@mui/icons-material/Balance';
import { ToolsPanelToggleButton } from "../../../screens/positions-and-orders/controls";

export function DeltaNeutralPriceSwitcher() {
    const {
        selectedPortfolio,
    } = usePortfolioSelection();
    const {
        saveSelectedPortfolio,
    } = usePortfolioManagement();
    const {
        updateSelectedPortfolio,
    } = usePortfolioProfile();

    const initialValue = selectedPortfolio !== null && selectedPortfolio.portfolioSettings !== null
        ? selectedPortfolio.portfolioSettings.showDeltaNeutralPriceLines
        : false;
    
    const [showDeltaNeutralPriceLines, setShowDeltaNeutralPriceLines] = useState<boolean>(initialValue);

    useEffect(() => {
        if (selectedPortfolio !== null && selectedPortfolio.portfolioSettings !== null)
            setShowDeltaNeutralPriceLines(selectedPortfolio.portfolioSettings.showDeltaNeutralPriceLines);
    }, [selectedPortfolio]);
    
    const onChange = async () => {
        const newValue = !showDeltaNeutralPriceLines;

        setShowDeltaNeutralPriceLines(newValue);
        
        if (selectedPortfolio !== null && selectedPortfolio.portfolioSettings !== null) {
            selectedPortfolio.portfolioSettings.showDeltaNeutralPriceLines = newValue;
            updateSelectedPortfolio();
            saveSelectedPortfolio();
        }
    }
    
    return (
        <ToolsPanelToggleButton
            isActivated={showDeltaNeutralPriceLines}
            setIsActivated={() => { void onChange(); }}
            tooltipTextWhenActivated="Hide a delta-neutral price lines for portfolios"
            tooltipTextWhenDeactivated="Show a delta-neutral price lines for portfolios"
            sx={{
                marginTop: '10px',
                marginLeft: '-20px',
            }}
        >
            <BalanceIcon sx={{
                height: '18px',
                width: '18px',
            }} />
        </ToolsPanelToggleButton>
    );
}
